import { getTrackingHeadersMap } from "./getTrackingHeaders";
import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IOhFollowUp, IOhInvestigation } from "../models/onHandDelivery";
import { throwApiError } from "./apiError";
import { getHeaderActionType, getTerminalId } from "../helpers";
/**
 * CRETE API call using Axios
 * @returns - Save and submit Investigation api and return same object
 */

export const OnHandInvestigationAPI = async (
  params: IOhFollowUp | IOhInvestigation,
  osdNumber: number,
  action: string
) => {
  try {
    const url = `${getUrl(ApiType.ON_HAND_INVESTIGATION).replace(
      ":osdNumber",
      osdNumber.toString()
    )}/${action}`;
    // Get static headers from map
    const staticHeaders = getTrackingHeadersMap(ApiType.ON_HAND_INVESTIGATION) || {};
    // Add dynamic values
    const headers = {
      ...staticHeaders,
      "OSD-Destination-Terminal": getTerminalId(),
      "OSD-Action-Type": getHeaderActionType(action),
      "OSD-Exception-Number": osdNumber?.toString(),
    };
    const response = await axios.post(url, params, { headers });
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.ohInvestigationError);
  }
};
